import { render, staticRenderFns } from "./view-file.vue?vue&type=template&id=1d7a1b8d&scoped=true&"
import script from "./view-file.vue?vue&type=script&lang=js&"
export * from "./view-file.vue?vue&type=script&lang=js&"
import style0 from "./view-file.vue?vue&type=style&index=0&id=1d7a1b8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7a1b8d",
  null
  
)

export default component.exports